// extracted by mini-css-extract-plugin
export default {"overlay":"ColumnsFilter_overlay__8oLpd","icon":"ColumnsFilter_icon__wIg-0"};